import { render, staticRenderFns } from "./SchoolManage.vue?vue&type=template&id=01a368b4&scoped=true&"
import script from "./SchoolManage.vue?vue&type=script&lang=js&"
export * from "./SchoolManage.vue?vue&type=script&lang=js&"
import style0 from "./SchoolManage.vue?vue&type=style&index=0&id=01a368b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a368b4",
  null
  
)

export default component.exports